import { render, staticRenderFns } from "./regular-edm-detail.vue?vue&type=template&id=21430f43&scoped=true&"
import script from "./regular-edm-detail.vue?vue&type=script&lang=js&"
export * from "./regular-edm-detail.vue?vue&type=script&lang=js&"
import style0 from "./regular-edm-detail.vue?vue&type=style&index=0&id=21430f43&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21430f43",
  null
  
)

export default component.exports